import { gql } from '@apollo/client';

export const UPSERT_WORKSPACE_FORM_SUBMISSION = gql`
  mutation upsertWorkspaceFormSubmission($input: UpsertWorkspaceFormSubmissionInput!) {
    workspaceFormSubmission: upsertWorkspaceFormSubmission(input: $input) {
      id
    }
  }
`;
